module.exports = require("@jswork/next-slate-plugin");